import { nip19 } from 'nostr-tools';
import { useParams } from 'react-router-dom';
import NotFound from './NotFound';
import { ContactFooter } from '@/components/ContactFooter';

export function NIP19Page() {
  const { nip19: identifier } = useParams<{ nip19: string }>();

  if (!identifier) {
    return <NotFound />;
  }

  let decoded;
  try {
    decoded = nip19.decode(identifier);
  } catch {
    return <NotFound />;
  }

  const { type } = decoded;

  switch (type) {
    case 'npub':
    case 'nprofile':
      // AI agent should implement profile view here
      return <div className="min-h-screen"><div>Profile placeholder</div><ContactFooter /></div>;

    case 'note':
      // AI agent should implement note view here
      return <div className="min-h-screen"><div>Note placeholder</div><ContactFooter /></div>;

    case 'nevent':
      // AI agent should implement event view here
      return <div className="min-h-screen"><div>Event placeholder</div><ContactFooter /></div>;

    case 'naddr':
      // AI agent should implement addressable event view here
      return <div className="min-h-screen"><div>Addressable event placeholder</div><ContactFooter /></div>;

    default:
      return <NotFound />;
  }
} 